import React from 'react';
import toolActions from '../../redux/futures/tools/actions';
import _ from 'lodash';
import { connect } from 'react-redux';

import moment from 'moment';
import * as types from '../../redux/futures/tools/types';
import appConst from '../../config/const';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import "react-datepicker/dist/react-datepicker.css";
import Input from '../../components/Input';

class ExportReportTraffic extends React.Component {

    constructor(props) {
        super(props);
        const date = new Date();
        const dayBefore3Days = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 2, 23, 59, 59);
        // console.log(dayBefore3Days);
        this.state = {
            activePage: 1,
            fromDate: moment(dayBefore3Days),
            toDate: moment(new Date()),
            url: '',
            message: '',
            submitData: false,
            excelDatas: [],
            classNormal: "ladiui button primary",
            classLoading: "ladiui loader button primary",
            classApply: "ladiui button primary",
        }

        this.sortBy = {
            'store_id': 'ASC',
            'name': 'ASC',
            'created_at': 'ASC',
            'status': 'ASC',
        }
        this.muteActions = [];

        this.inputsRef = new Set();

    }


    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {

            if (nextProps.action == types.EXPORT_REPORT_TRAFFIC) {
                this.setState({
                    loading: false,
                    classApply: this.state.classNormal
                });
                if (nextProps.status) {
                    this.setState({
                        message: nextProps.result
                    })
                } else {
                    window.LadiUI.toastr('error', '', nextProps.message);
                }
            }

        }
    }
    submit = () => {
        // Validate
        let errors = [];
        const inputsRef = _.compact(Array.from(this.inputsRef));
        _.map(inputsRef, ref => {
            // console.log(ref);
            if (ref.validate) {
                errors = errors.concat(ref.validate());
            }
        });

        _.compact(errors);
        if (errors.length > 0) {
            const errorMessage = errors.join("<br/>");
            window.LadiUI.toastr('error', '', errorMessage);
            return;
        }
        const { fromDate, toDate, url } = this.state;
        // console.log(fromDate, toDate);
        // Normalize to full-day range in UTC (midnight UTC)


        // Check accept only date in 3 days, include today
        const today = moment();
        const threeDaysAgo = moment().subtract(3, 'days');
        if (fromDate.isBefore(threeDaysAgo) || toDate.isAfter(today.endOf('day'))) {
            window.LadiUI.toastr('error', '', 'Ngày tải báo cáo phải nằm trong khoảng 3 ngày gần nhất');
            return;
        }
        const fromDateStart = fromDate && moment.utc(fromDate).startOf('day');
        const toDateEnd = toDate && moment.utc(toDate).endOf('day');

        const jsonData = {
            from_time: fromDateStart,
            to_time: toDateEnd,
            url: url
        }
        this.props.exportReportTraffic(jsonData);

        this.state.loading = true;
        this.state.classApply = this.state.classLoading;

    }

    changeFromdate = (date) => {
        this.setState({
            fromDate: date
        });

    }

    changeTodate = (date) => {
        this.setState({
            toDate: date
        });

    }
    onChangeInput = (event) => {

        this.setState({
            url: event.target.value
        });
    }

    render() {

        const { url, message } = this.state;

        const title = 'Chọn thời gian để tải báo cáo';
        return (
            <div ref={this.ref} id="modal-export-report-traffic" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-export-report-traffic">
                <div className="ladiui-modal-content" >
                    <div className="ladiui-modal-header"><button type="button" className="ladiui-close-modal" data-dismiss="modal-export-report-traffic"><i className="ladi-icon icon-e-remove" data-dismiss="modal-export-report-traffic" /></button>
                        <h3>{title}</h3>
                    </div>
                    <div className="ladiui-modal-body">

                        <div className="ladiui-tab-content" style={{ height: "500px" }}>
                            {
                                message &&
                                <label className="ladiui-label">{message}</label>
                            }
                            <div className="ladiui form-group">
                                <label className="ladiui-label">Tên miền</label>
                                <Input
                                    ref={(ref) => this.inputsRef.add(ref)}
                                    name="url"
                                    validationName="Đường dẫn trang"
                                    placeholder="Đường dẫn trang "
                                    value={url}
                                    onChange={this.onChangeInput}
                                    validations={{ isRequired: true }}
                                />

                            </div>
                            <DateRangePicker
                                startDateId="fromDate"
                                endDateId="toDate"
                                startDate={this.state.fromDate}
                                endDate={this.state.toDate}
                                onDatesChange={({ startDate, endDate }) => {
                                    this.setState({
                                        fromDate: startDate,
                                        toDate: endDate,
                                    }, () => {
                                        if (endDate) {

                                        }
                                    })
                                }}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={(focusedInput) => { this.setState({ focusedInput }) }}
                                showDefaultInputIcon={true}
                                inputIconPosition="after"
                                small={true}
                                hideKeyboardShortcutsPanel={true}
                                customInputIcon={
                                    <i className="ladi-icon icon-calendar" />
                                }
                                displayFormat={() => appConst.DEFAULT_FORMAT_DATE_NEW}
                                // startDatePlaceholderText={appConst.DEFAULT_FORMAT_DATE}
                                // endDatePlaceholderText={appConst.DEFAULT_FORMAT_DATE}
                                isOutsideRange={() => false}
                                isDayHighlighted={(date) => {
                                    return moment(new Date()).isSame(date, 'day');
                                }}
                            />

                        </div>


                    </div>

                    <div className="ladiui-modal-footer">
                        <button className="ladiui button secondary close-modal icon" data-dismiss="modal-export-report-traffic">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-export-report-traffic" />Đóng
                        </button>
                        <button
                            ref={this.ref}
                            className={this.state.classApply}
                            onClick={this.submit}
                            disabled={this.state.loading}
                        >
                            <i className="ladi-icon icon-floppy-disk" style={{ display: (this.state.loading) ? 'none' : '', paddingRight: '5px' }}></i>
                            Tải file Exel
                        </button>

                    </div>
                </div>

            </div >
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        exportReportTraffic: (data) => dispatch(toolActions.exportReportTraffic(data)),

    }
}

const mapStateToProps = (state) => ({ ...state.tool });

export default connect(mapStateToProps, mapDispatchToProps)(ExportReportTraffic);